(function () {
  var mob = innerWidth <= 749;
  var cfg = window.N1M2 || {}, ar = !!cfg.ar;
  function L(a, e) { return ar ? a : e; }
  var BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var SRCH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M12 20s-7.5-4.6-9-9.2C2 7.300 4.300 5 7 5c2 0 3.700 1.100 5 3 1.300-1.900 3-3 5-3 2.700 0 5 2.300 4 5.800C19.500 15.400 12 20 12 20z"/></svg>';
  var SHARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15V4M8 8l4-4 4 4M6 12H5v8h14v-8h-1"/></svg>';
  function back() { if (history.length > 1 && document.referrer.indexOf(location.host) > -1) history.back(); else location.href = '/'; }
  function btn(cls, label, svg, fn) { var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.setAttribute('aria-label', label); b.innerHTML = svg; b.onclick = fn; return b; }

  function searchCancel() {
    var w = document.querySelector('.n1-hd__search'); if (!w) return;
    var c = document.createElement('button'); c.type = 'button'; c.className = 'n1m-cancel'; c.textContent = L('إلغاء', 'Cancel');
    c.onclick = function () { var q = w.querySelector('[data-n1-q]'); q.value = ''; q.dispatchEvent(new Event('input')); q.blur(); w.querySelector('.n1-sr').hidden = true; };
    w.appendChild(c);
  }
  function plpBar() {
    var plp = document.querySelector('.n1-plp'), h = document.querySelector('.n1-tb__title h1'); if (!plp) return;
    var t = document.createElement('div'); t.className = 'n1m-tb';
    t.appendChild(btn('n1m-tb__back', L('رجوع', 'Back'), BACK, back));
    var title = document.createElement('h1'); title.textContent = h ? h.textContent : ''; title.setAttribute('aria-hidden', 'true'); t.appendChild(title);
    t.appendChild(btn('n1m-tb__s', L('بحث', 'Search'), SRCH, function () { var q = document.querySelector('[data-n1-q]'); if (q) q.focus(); }));
    plp.parentNode.insertBefore(t, plp);
  }
  function pdpBar() {
    var pdp = document.querySelector('.n1-pdp'); if (!pdp) return;
    var wish = pdp.querySelector('.n1-pdp__wish');
    var t = document.createElement('div'); t.className = 'n1m-tb n1m-tb--p';
    t.appendChild(btn('n1m-tb__back', L('رجوع', 'Back'), BACK, back));
    var sp = document.createElement('span'); sp.className = 'n1m-tb__sp'; t.appendChild(sp);
    t.appendChild(btn('n1m-tb__share', L('مشاركة', 'Share'), SHARE, function () { if (navigator.share) navigator.share({ title: document.title, url: location.href }).catch(function () {}); else if (navigator.clipboard) navigator.clipboard.writeText(location.href); }));
    var hb = btn('n1m-tb__wish', L('المفضلة', 'Wishlist'), HEART, function () { if (wish) wish.click(); });
    t.appendChild(hb);
    if (wish) { var sync = function () { hb.setAttribute('aria-pressed', wish.getAttribute('aria-pressed') || 'false'); }; sync(); new MutationObserver(sync).observe(wish, { attributes: true }); }
    pdp.parentNode.insertBefore(t, pdp);
  }

  function money(c) {
    var n = (Number(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (ar) return n + ' ر.س.';
    var fmt = (window.KSX_CART && KSX_CART.moneyFormat) || '{{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
  }
  var pc = {};
  function prod(h) { return pc[h] || (pc[h] = fetch((cfg.root || '/').replace(/\/$/, '') + '/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; })); }
  function cartUx() {
    var root = document.getElementById('KsxCart'); if (!root) return;
    var items = root.querySelector('[data-ksx-cart-items]'), foot = root.querySelector('[data-ksx-cart-foot]');
    var label = foot.querySelector('.ksx-cd__row span'), sub = foot.querySelector('[data-ksx-cart-subtotal]');
    label.textContent = cfg.taxIncl ? L('الإجمالي (شامل الضريبة)', 'Total (tax included)') : L('الإجمالي', 'Total');
    var rh = root.querySelector('.ksx-cd__reco-head h3'); if (rh) rh.textContent = L('المنتجات الموصى بها', 'Recommended products');
    var save = document.createElement('small'); save.className = 'n1m-save'; save.hidden = true; sub.insertAdjacentElement('afterend', save);
    var seq = 0;
    function enhance() {
      var my = ++seq;
      fetch((cfg.root || '/').replace(/\/$/, '') + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        return Promise.all(cart.items.map(function (it) { return prod(it.handle); })).then(function (ps) {
          if (my !== seq) return;
          var total = 0, base = 0;
          cart.items.forEach(function (it, i) {
            var p = ps[i], v = p && p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
            var unit = Math.max(it.original_price || 0, (v && v.compare_at_price) || 0);
            var was = unit * it.quantity, now = it.final_line_price;
            base += Math.max(was, now);
            if (was <= now) return;
            total += was - now;
            var row = items.querySelector('[data-line="' + (i + 1) + '"] .ksx-cd__price'); if (!row) return;
            row.innerHTML = '<s>' + money(was) + '</s><br>' + money(now) + '<span class="n1m-pct">-' + Math.round((was - now) * 100 / was) + '%</span>';
          });
          save.hidden = total <= 0;
          save.textContent = L('قمت بتوفير ', 'You saved ') + money(total) + (base ? ' (' + Math.round(total * 100 / base) + '%)' : '');
        });
      }).catch(function () {});
    }
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(enhance, 60); }).observe(items, { childList: true });
    var pass = false;
    document.addEventListener('click', function (e) {
      if (pass) return;
      var b = e.target.closest && e.target.closest('#KsxCart [data-ksx-qty="0"]'); if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var d = document.createElement('div'); d.className = 'n1m-dlg'; d.setAttribute('role', 'alertdialog');
      d.innerHTML = '<div><p>' + L('هل أنت متأكد من حذف هذا المنتج؟', 'Are you sure you want to remove this product?') + '</p><span><button type="button" class="n1m-dlg__x">' + L('إغلاق', 'Close') + '</button><button type="button" class="n1m-dlg__del">' + L('حذف', 'Delete') + '</button></span></div>';
      d.querySelector('.n1m-dlg__x').onclick = function () { d.remove(); };
      d.querySelector('.n1m-dlg__del').onclick = function () { d.remove(); pass = true; b.click(); pass = false; };
      root.querySelector('.ksx-cd__panel').appendChild(d);
    }, true);
  }
  function start() {
    if (mob) {
      searchCancel();
      var c = document.body.classList;
      if (c.contains('template-collection')) plpBar();
      if (c.contains('template-product')) pdpBar();
    }
    cartUx();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
